import React from "react";
import { Button } from "antd";
import { DeleteOutlined, SettingOutlined, ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { setWidgetDisplay } from "../db/action";
import { WidgetState } from "../db/state";
import { useToggle } from "../hooks";
import { getConfig } from "../plugins";
import PluginContainer from "./Plugin";
import ToggleSection from "./ToggleSection";
import "./SettingWidget.sass";
import WidgetDisplay from "./SettingWidgetDisplay";

interface Props {
  plugin: WidgetState;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  onRemove: () => void;
}

const SettingWidget: React.FC<Props> = ({
  plugin,
  onMoveDown,
  onMoveUp,
  onRemove,
}) => {
  const [isOpen, toggleIsOpen] = useToggle(onRemove === undefined);

  const { description, name, settingsComponent } = getConfig(plugin.key);

  const setDisplay = setWidgetDisplay.bind(null, plugin.id);

  return (
    <fieldset className="Widget">
      <div className="title--buttons">
        <Button  onClick={onRemove} title="Remove widget" shape="circle" icon={<DeleteOutlined />} />
        <Button  onClick={toggleIsOpen}  title={`${isOpen ? "Close" : "Edit"} widget settings`} shape="circle" icon={<SettingOutlined />} />

       

        {onMoveDown && (
          <Button  onClick={onMoveDown}  title="Move widget down" shape="circle" icon={<ArrowDownOutlined />} />
        )}

        {onMoveUp && (
          <Button  onClick={onMoveUp}  title="Move widget up" shape="circle" icon={<ArrowUpOutlined />} />
        )}

        <h4 onClick={toggleIsOpen}>{name}</h4>
        {!isOpen && <p>{description}</p>}
      </div>

      {isOpen && (
        <div>
          {settingsComponent && (
            <div className="settings">
              <PluginContainer id={plugin.id} component={settingsComponent} />
            </div>
          )}
          <WidgetDisplay display={plugin.display} onChange={setDisplay} />
          {/* <ToggleSection name="Display Settings">
            <WidgetDisplay display={plugin.display} onChange={setDisplay} />
          </ToggleSection> */}

          <ToggleSection name="Font Settings">
            <>
              <label>
                Font
                <input
                  type="text"
                  value={plugin.display.fontFamily}
                  onChange={(event) =>
                    setDisplay({ fontFamily: event.target.value })
                  }
                />
              </label>

              <label>
                Weight
                <select
                  value={plugin.display.fontWeight}
                  onChange={(event) =>
                    setDisplay({
                      fontWeight: event.target.value
                        ? Number(event.target.value)
                        : undefined,
                    })
                  }
                >
                  <option value="">Default</option>
                  <option value="100">Thin</option>
                  <option value="300">Light</option>
                  <option value="400">Regular</option>
                  <option value="500">Medium</option>
                  <option value="700">Bold</option>
                  <option value="900">Black</option>
                </select>
              </label>

              <label>
                Colour
                <input
                  type="color"
                  value={plugin.display.colour ?? "#ffffff"}
                  onChange={(event) =>
                    setDisplay({ colour: event.target.value })
                  }
                />
              </label>
            </>
          </ToggleSection>
        </div>
      )}
    </fieldset>
  );
};

export default SettingWidget;
